// register — am. Part of the am i18n bundle; merged by ./index.js

export default {
  fullName: 'ሙሉ ስም *',
  email: 'ኢሜይል',
  phone: 'ስልክ *',
  company: 'የኩባንያ ስም',
  businessType: 'የንግድ አይነት',
  tin: 'TIN ቁጥር',
  elmis: 'E-LMIS ምዝገባ',
  submit: 'ማመልከቻ ያስገቡ →',
  submitting: 'በማስገባት ላይ...',
  accountDetails: 'የመለያ ዝርዝሮች',
  businessInfo: 'የንግድ መረጃ',
  nextBusiness: 'ቀጣይ: የንግድ መረጃ →',
  nextDocs: 'ቀጣይ: ሰነዶች →',
  businessLicenseReq: 'የንግድ ፈቃድ ቁጥር ያስፈልጋል።',
  licenseInfo: '📋 መረጃዎ በቡድናችን ይገመገማል። ከተመዘገቡ በኋላ ኢሜይል ይደርስዎታል።',
  phoneLabel2: 'ስልክ ቁጥር *',
  emailLabel: 'ኢሜይል (አማራጭ)',
  fullNameLabel: 'ሙሉ ስም *',
  fillRequired: 'ሁሉንም አስፈላጊ መስኮች ይሙሉ።',
  passwordShort: 'የይለፍ ቃሉ ቢያንስ 6 ቁምፊዎች መሆን አለበት።',
  companyRequired: 'የኩባንያ ስም ያስፈልጋል።',
  phoneLabel: 'ስልክ ቁጥር',
  passwordLabel: 'የይለፍ ቃል',
  phoneMustBe9: 'ስልኩ 9 ቁምፊዎች መሆን አለበት',
  alertFullNameRequired: 'ሙሉ ስም ያስፈልጋል',
  alertPhoneDigits: 'ስልኩ 9 ቁምፊዎች መሆን አለበት (ለምሳሌ 911031884)',
  alertValidEmail: 'እባክዎ ትክክለኛ የኢሜይል አድራሻ ያስገቡ',
  alertSubmissionFailed: 'ማስገባት አልተሳካም። እባክዎ እንደገና ይሞክሩ።',
  companyToggle: 'እንደ ኩባንያ ይላኩ',
  alertCompanyRequired: 'የኩባንያ ስም ያስፈልጋል።',
  alertTinRequired: 'የTIN ቁጥር ያስፈልጋል።',
  alertElmisRequired: 'የE-LMIS ምዝገባ ያስፈልጋል።',
  alertBusinessTypeRequired: 'የንግድ አይነት ያስፈልጋል።',
// Chat,
  businessTypeLabel: 'የንግድ አይነት',
};

